import config from './config'
import http from './http'

export default {
  login: function(param, success, error) {
    http.post(param, config, success, error);
  },
  logout: function() {
    http.logout();
  },

  loginHanlder:{
    checkLogin(param, success, error){
      let option = {
        fn: "mallmem.memLoginHandler.isLogined",
        param: param
      }
      return http.post(option, config, success, error);
    }
  },
  wxHandler: {
    //8.1.获取首页头部导航栏
    getWxJsSdkConfig(param, success, error){
      let option = {
        fn: "mallsale.wxHandler.getWxJsSdkConfig",
        param: param
      }
      return http.post(option, config, success, error);
    },
  },
  /*
  * 获取首页头部导航栏
  * @type {Object}
  */
  navBarHandler: {
    //8.1.获取首页头部导航栏
    getHomeHeaderNavs(param, success, error){
      let option = {
        fn: "mallsale.navBarHandler.getHomeHeaderNavs",
        param: param
      }
      return http.post(option, config, success, error);
    },
  },

  /*
  * 17.商品查询（列表）API
  * @type {Object}
  */
  goodsSearchHandler: {
    //17.1.获取排序列表
    goodsSearchHandler(param, success, error){
      let option = {
        fn: "mallsale.goodsSearchHandler.getGoodsSearchSort",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //17.2.商品分页查询
    pageGoods(param, success, error){
      let option = {
        fn: "mallsale.goodsSearchHandler.pageGoods",
        param: param
      }
      return http.post(option, config, success, error);
    },

  },

  /*
  *购物车API
  * @type {Object}
   */
  cartHandler: {
    //13.1.获取购物车信息
    getCartInfo(param, success, error){
      let option = {
        fn: "mallsale.cartHandler.getCartInfo",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //13.4.增加购物车商品数量
    incrMemCartNum(param, success, error){
      let option = {
        fn: "mallsale.cartHandler.incrMemCartNum",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //13.5.修改购物车商品数量
    changeMemCartNum(param, success, error){
      let option = {
        fn: "mallsale.cartHandler.changeMemCartNum",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //13.6.减少购物车商品数量
    decrMemCartNum(param, success, error){
      let option = {
        fn: "mallsale.cartHandler.decrMemCartNum",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //13.7.从购物车中删除商品
    removeMemCart(param, success, error){
      let option = {
        fn: "mallsale.cartHandler.removeMemCart",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //13.8.从购物车中批量删除商品
    removeMemCarts(param, success, error){
      let option = {
        fn: "mallsale.cartHandler.removeMemCarts",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //13.12.从购物车加入收藏夹
    addMemFavFormCart(param, success, error){
      let option = {
        fn: "mallsale.cartHandler.addMemFavFormCart",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //13.13.从购物车加入收藏夹-批量
    addMemFavBatchFormCart(param, success, error){
      let option = {
        fn: "mallsale.cartHandler.addMemFavBatchFormCart",
        param: param
      }
      return http.post(option, config, success, error);
    },
  },

  /*
  *结算API
  * @type {Object}
  */
  settleHandler: {
    //15.1.从购物车结算
    getOrderSettleMsgFromCart(param, success, error){
      let option = {
        fn: "mallsale.settleHandler.getOrderSettleMsgFromCart",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //15.4.提交订单
    createOrder(param, success, error){
      let option = {
        fn: "mallsale.settleHandler.createOrder",
        param: param
      }
      return http.post(option, config, success, error);
    },
  },

  /*
  *发票API
  * @type {Object}
  */
  invoiceHandler: {
    //14.1.分页查询会员发票信息
    pageMemOrderInvoice(param, success, error){
      let option = {
        fn: "mallsale.invoiceHandler.pageMemOrderInvoice",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //14.2.获取发票类型列表
    listInvoiceType(param, success, error){
      let option = {
        fn: "mallsale.invoiceHandler.listInvoiceType",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //14.3.获取发票内容列表
    listInvoiceContent(param, success, error){
      let option = {
        fn: "mallsale.invoiceHandler.listInvoiceContent",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //14.4.获取会员单位发票列表
    listMemInvoiceMsg(param, success, error){
      let option = {
        fn: "mallsale.invoiceHandler.listMemInvoiceMsg",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //14.5.保存会员单位发票
    saveMemInvoice(param, success, error){
      let option = {
        fn: "mallsale.invoiceHandler.saveMemInvoice",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //14.6.删除会员单位发票
    removeMemInvoice(param, success, error){
      let option = {
        fn: "mallsale.invoiceHandler.removeMemInvoice",
        param: param
      }
      return http.post(option, config, success, error);
    },
  },

  /*
  *地址API
  * @type {Object}
  */
  addressHandler: {
    //7.6.列出收货地址
    listAddress(param, success, error){
      let option = {
        fn: "mallmem.addressHandler.listAddress",
        param: param
      }
      return http.post(option, config, success, error);
    },
  },

  /*
  *12.优惠券、红包相关API
  * @type {Object}
  */
  couponHandler: {
    //12.1.分页查询会员优惠券
    pageMemCoupon(param, success, error){
      let option = {
        fn: "mallsale.couponHandler.pageMemCoupon",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //12.2.删除会员优惠券、红包
    delMemCoupon(param, success, error){
      let option = {
        fn: "mallsale.couponHandler.delMemCoupon",
        param: param
      }
      return http.post(option, config, success, error);
    },
    //12.3.分页查询会员红包
    pageMemRedpacket(param, success, error){
      let option = {
        fn: "mallsale.couponHandler.pageMemRedpacket",
        param: param
      }
      return http.post(option, config, success, error);
    },
  },

}





// WEBPACK FOOTER //
// ./src/service/api.js